<script lang="ts">
  import Input from '$lib/components/ui/input/input.svelte'
  import { t } from '$lib/translations'
  import Button from '$lib/components/ui/button/button.svelte'
  import * as Tooltip from '$lib/components/ui/tooltip'
  import { Info } from 'lucide-svelte'
</script>

<form method="POST" action="?/my_booking" data-test-id="my-booking-tab">
  <div class="form-group">
    <label class="text-xs uppercase" for="voucher">{$t('common.voucher')} </label>
    <Input
      name="voucher"
      type="text"
      placeholder="H-545AS"
      class="w-full active:bg-white border-none rounded-none focus-visible:ring-transparent text-sm"
      required
    />
  </div>
  <div class="form-group">
    <label class="text-xs uppercase" for="flight_date"
      >{$t('mybooking.flight_date')}<Tooltip.Root>
        <Tooltip.Trigger class="ml-1">
          <Info class="cursor-pointer h-[13.5px] w-[13.5px]" />
        </Tooltip.Trigger>
        <Tooltip.Content>
          {$t('mybooking.date_tooltip')}
        </Tooltip.Content>
      </Tooltip.Root></label
    >
    <Input
      name="flight_date"
      type="date"
      class="w-full active:bg-white border-none rounded-none focus-visible:ring-transparent text-sm"
    />
  </div>
  <div class="form-group">
    <label class="text-xs uppercase" for="email"
      >{$t('common.email')}
      <Tooltip.Root>
        <Tooltip.Trigger class="ml-1">
          <Info class="cursor-pointer h-[13.5px] w-[13.5px]" />
        </Tooltip.Trigger>
        <Tooltip.Content>
          {$t('mybooking.email_tooltip')}
        </Tooltip.Content>
      </Tooltip.Root></label
    >
    <Input
      name="email"
      type="email"
      placeholder="email@email.com"
      class="w-full active:bg-white border-none rounded-none focus-visible:ring-transparent text-sm"
    />
  </div>

  <Button
    id="submit-my-booking"
    type="submit"
    class="rounded-none transition-all hover:bg-cs-light-orange h-12 flex bg-cs-orange uppercase p-0 text-white ml-4 mt-2 mb-4"
  >
    <span class="px-8">{$t('common.search')}</span>
  </Button>
</form>
